import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

import { type IPikProjectsItemViewModel } from '../../external/models/PikProjectsItemViewModel';

/**
 * @description Событие: пользователь переключил режим отображения проектов (например, список / карта).
 */
export function trackPikProjectsViewMode(viewModel: IPikProjectsItemViewModel): void {
  const label = viewModel.type === 'map' ? 'map_offers' : 'tile_offers';

  ca('eventSite', {
    action: 'click_pik_projects_view',
    category: 'Promo',
    label,
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
